import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./tag.html";
export let Variant = /*#__PURE__*/function (Variant) {
  Variant["Primary"] = "primary";
  Variant["Secondary"] = "secondary";
  return Variant;
}({});
class Tag extends LightningElement {
  constructor(...args) {
    super(...args);
    this.disabled = false;
    this.text = null;
    this.href = null;
    this.variant = Variant.Primary;
  }
  get analyticsSourceProps() {
    return {
      disabled: this.disabled,
      callToAction: {
        label: this.text,
        url: this.href
      },
      variant: this.variant
    };
  }
  handleAnalytics(event) {
    event.detail.tag = this.analyticsSourceProps;
  }
  handleClick(event) {
    if (this.disabled) {
      event.stopPropagation();
    }
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Tag, {
  publicProps: {
    disabled: {
      config: 0
    },
    text: {
      config: 0
    },
    href: {
      config: 0
    },
    variant: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(Tag, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;